import React, { useState, useEffect } from 'react';
import liff from '@line/liff';

const ContactUsPage = () => {
  const [profile, setProfile] = useState({
    displayName: '',
    name: '',
    email: '',
    pictureUrl: '',
    message: ''
  });

  useEffect(() => {
    const initLiff = async () => {
      try {
        await liff.init({ liffId: process.env.REACT_APP_LIFF_ID3 });
        if (!liff.isLoggedIn()) {
          liff.login();
          return;
        }
        const userProfile = await liff.getProfile();
        const idToken = liff.getDecodedIDToken();

        setProfile({
          displayName: userProfile.displayName || '',
          name: idToken.name || '',
          email: idToken?.email || '',
          pictureUrl: userProfile.pictureUrl || '',
          message: ''
        });
      } catch (error) {
        console.error(error);
      }
    };
    initLiff();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfile(prev => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Kanit:wght@300;400;500;600&display=swap');

        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
          font-family: 'Kanit', sans-serif;
        }

        .contact-page {
          min-height: 100vh;
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          background-attachment: fixed;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        }

        .container {
          width: 100%;
          max-width: 1100px;
          background: rgba(255, 255, 255, 0.8);
          backdrop-filter: blur(15px);
          border-radius: 40px;
          display: grid;
          grid-template-columns: 1fr 1.4fr;
          overflow: hidden;
          box-shadow: 0 30px 60px rgba(0,0,0,0.12);
          border: 1px solid rgba(255, 255, 255, 0.5);
        }

        /* --- ฝั่งซ้าย: ติดต่อเรา (สีเด่น) --- */
        .card-left {
          background: #7c3aed;
          background: linear-gradient(160deg, #7c3aed 0%, #ec4899 100%);
          color: white;
          padding: 60px 40px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          position: relative;
        }

        .card-left h1 {
          font-size: 40px;
          font-weight: 600;
          line-height: 1.2;
          margin-bottom: 20px;
        }

        .contact-details {
          margin-top: 30px;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 25px;
          font-size: 17px;
          background: rgba(255, 255, 255, 0.1);
          padding: 15px;
          border-radius: 20px;
          transition: 0.3s;
        }

        .contact-item:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: translateX(5px);
        }

        /* --- ฝั่งขวา: แบบฟอร์ม --- */
        .card-right {
          background: white;
          padding: 60px;
        }

        .profile-header {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 35px;
        }

        .profile-img {
          width: 65px;
          height: 65px;
          border-radius: 22px;
          box-shadow: 0 8px 20px rgba(124, 58, 237, 0.2);
          object-fit: cover;
        }

        .profile-text b { color: #7c3aed; font-size: 18px; }

        h2 { font-size: 28px; color: #1e293b; margin-bottom: 30px; font-weight: 600; }

        .input-group {
          margin-bottom: 20px;
          text-align: left;
        }

        .input-group label {
          display: block;
          font-size: 14px;
          color: #64748b;
          margin-bottom: 8px;
          padding-left: 5px;
        }

        input, textarea {
          width: 100%;
          padding: 16px 20px;
          border: 2px solid #f1f5f9;
          border-radius: 18px;
          font-size: 16px;
          background: #f8fafc;
          transition: all 0.3s ease;
        }

        input:focus, textarea:focus {
          outline: none;
          border-color: #7c3aed;
          background: white;
          box-shadow: 0 10px 20px rgba(124, 58, 237, 0.05);
        }

        button {
          width: 100%;
          padding: 18px;
          border: none;
          border-radius: 20px;
          background: #1e293b;
          color: white;
          font-size: 18px;
          font-weight: 600;
          cursor: pointer;
          transition: 0.3s ease;
          margin-top: 10px;
        }

        button:hover {
          background: #7c3aed;
          transform: translateY(-3px);
          box-shadow: 0 15px 30px rgba(124, 58, 237, 0.3);
        }

        /* --- RESPONSIVE FOR MOBILE --- */
        @media (max-width: 900px) {
          .contact-page { padding: 10px; align-items: flex-start; }
          
          .container {
            grid-template-columns: 1fr;
            border-radius: 30px;
          }

          .card-left {
            order: 1; /* ติดต่อเราอยู่ด้านบน */
            padding: 40px 30px;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
          }

          .card-right {
            order: 2; /* ฟอร์มอยู่ด้านล่าง */
            padding: 40px 25px;
          }

          .card-left h1 { font-size: 30px; }
          .contact-item { font-size: 15px; padding: 12px; }
          .profile-img { width: 55px; height: 55px; }
        }
      `}</style>

      <div className="contact-page">
        <div className="container">
          {/* ข้อมูลติดต่อ (แสดงด้านบนในมือถือ) */}
          <div className="card-left">
            <div>
              <h1>Contact Us.</h1>
              <p style={{ opacity: 0.8, marginBottom: '20px' }}>
                หากต้องการสอบถามข้อมูลเพิ่มเติม ทีมงานของเราพร้อมให้บริการคุณตลอดเวลา
              </p>
              
              <div className="contact-details">
                <div className="contact-item">
                  <span>📞</span> 02-xxx-xxxx
                </div>
                <div className="contact-item">
                  <span>✉️</span> support@yourbrand.com
                </div>
                <div className="contact-item">
                  <span>📍</span> Ramkhamhaeng, Bangkok
                </div>
              </div>
            </div>
            
            <div style={{ opacity: 0.6, fontSize: '12px', marginTop: '30px' }}>
              © 2026 BRAND CO., LTD.
            </div>
          </div>

          {/* ฟอร์มส่งข้อความ */}
          <div className="card-right">
            {profile.pictureUrl && (
              <div className="profile-header">
                <img src={profile.pictureUrl} alt="User" className="profile-img" />
                <div className="profile-text">
                  <p style={{fontSize: '14px', color: '#64748b'}}>ยินดีต้อนรับ</p>
                  <b>คุณ {profile.displayName}</b>
                </div>
              </div>
            )}
            
            <h2>ส่งข้อความหาเรา</h2>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="input-group">
                <label>ชื่อผู้ติดต่อ</label>
                <input 
                  name="name"
                  placeholder="กรุณากรอกชื่อของคุณ" 
                  value={profile.name} 
                  onChange={handleInputChange} 
                />
              </div>

              <div className="input-group">
                <label>อีเมล</label>
                <input 
                  name="email"
                  type="email"
                  placeholder="email@example.com" 
                  value={profile.email} 
                  onChange={handleInputChange} 
                />
              </div>

              <div className="input-group">
                <label>ข้อความ</label>
                <textarea 
                  name="message"
                  rows="4" 
                  placeholder="พิมพ์รายละเอียดที่ต้องการสอบถาม..."
                  value={profile.message}
                  onChange={handleInputChange}
                ></textarea>
              </div>

              <button type="submit">ส่งข้อมูลติดต่อ</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUsPage;